import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from '@argos/utils/esnext/isEmpty'
import Pill from '../pill/Pill'

const clone = (item) => JSON.parse(JSON.stringify(item))
export default class FilterPills extends React.Component {
  state = {
    pills: this.props.pills
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pills !== this.props.pills) {
      this.setState({
        pills: this.props.pills
      })
    }
  }

  // Animation effect
  animatePills = (pillIndex) => {
    const { 'data-test': dataTest } = this.props
    const domPills = window.document.querySelectorAll(`[data-test^=${dataTest}-pill]`) // not using refs so that Pill can be functional

    if (!isEmpty(domPills)) {
      const pills = [...domPills]
      const offsets = this.getDomPillOffsets(pills, pillIndex)

      pills.forEach((ta, index) => {
        this.animateTranslateXToZero(ta, offsets[index])
      })
    }
  }

  getDomPillOffsets = (domPills, pillIndexToToggle) => {
    const pillToToggle = domPills[pillIndexToToggle]

    const startPositions = this.mapToLeftOffset(domPills)
    pillToToggle.style.order = pillToToggle.style.order === '-1' ? '0' : '-1'
    const endPositions = this.mapToLeftOffset(domPills)

    return startPositions.map((startPosition, index) => startPosition - endPositions[index])
  }

  mapToLeftOffset = (pills) => pills.map((pill) => pill.offsetLeft)

  animateTranslateXToZero = (pill, offset) => {
    if (offset && Math.abs(offset) > 0.1) {
      pill.style.transform = `translateX(${offset}px)`
      window.requestAnimationFrame(() => this.animateTranslateXToZero(pill, offset * 0.8))
    } else {
      pill.style.transform = null
    }
  }

  toggle = (pill, index, event) => {
    if (pill.href) return
    const { onActivate, onDeactivate } = this.props
    const { pills } = this.state

    const updatedPills = clone(pills)
    updatedPills[index].active = !updatedPills[index].active

    this.setState({
      pills: updatedPills
    })

    this.animatePills(index)
    event.preventDefault()
    event.stopPropagation()

    if (pill.active) onDeactivate(pill)
    if (!pill.active) onActivate(pill)
  }

  render() {
    const { pills } = this.state
    const { 'data-test': dataTest } = this.props
    return (
      <div style={{ display: 'inline-flex' }} data-test={dataTest}>
        {pills.map((pill, index) => (
          <Pill
            href={pill.href}
            target={pill.openNewTab ? '_blank' : '_self'}
            onClick={(event) => this.toggle(pill, index, event)}
            key={index}
            label={pill.label}
            active={pill.active}
            disabled={pill.disabled}
            data-test={`${dataTest}-pill-${index}`}
          />
        ))}
      </div>
    )
  }
}

FilterPills.propTypes = {
  /**
   * Specify the content of your FilterPills
   */
  pills: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
      active: PropTypes.bool,
      openNewTab: PropTypes.bool
    })
  ),

  /**
   * Optional prop to provide a callback function which is called when a Pill is activated
   */
  onActivate: PropTypes.func,

  /**
   * Optional prop to provide a callback function which is called when a Pill is deactivated
   */
  onDeactivate: PropTypes.func,

  /**
   * Specify an optional data-test attribute to be added to your FilterPills component for e2e testing
   */
  'data-test': PropTypes.string
}

FilterPills.defaultProps = {
  pills: [],
  onActivate: /* istanbul ignore next */ () => {},
  onDeactivate: /* istanbul ignore next */ () => {},
  'data-test': 'component-filter-pills'
}
